import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const ElegantFrame: React.FC<CoverTemplateProps> = ({
    fields,
    colors,
    logoUrl,
    showLogo,
}) => (
    <div className="size-full p-[1.5em]" style={{ fontFamily: COVER_DISPLAY_FONT_VAR }}>
        <div
            className="flex h-full flex-col items-center justify-between px-[2em] py-[2.6em] text-center"
            style={{ border: `1px solid ${colors.primary}` }}
        >
            <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
            <div className="flex flex-col gap-[0.5em]">
                <div
                    className="font-bold leading-[1.05] tracking-[-0.02em]"
                    style={{ fontSize: coverTitleSize(2.05) }}
                >
                    {fields.document_title}
                </div>
                {fields.subtitle ? (
                    <div className="text-[0.82em]" style={{ color: COVER_DIM_ON_LIGHT }}>
                        {fields.subtitle}
                    </div>
                ) : null}
            </div>
            <CoverMeta fields={fields} />
        </div>
    </div>
);
